<template>
  <div class="room-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "roomBase",
};
</script>
